// extracted by mini-css-extract-plugin
module.exports = {"renewButton":"UserSubscriptionsTable_renewButton__5kmxl","addButtonWrapper":"UserSubscriptionsTable_addButtonWrapper__2mJIB"};